<div class="container" role="main">
  <div class="HmsContainer">
    <div class="row">
      <div class="row HmsInsideContainer">
        <div class="col-md-12">
          <button type="button" class="greyBtn" (click)="back()" style="font-weight : bold;">Go to Previous
          Section</button>
          @if (isInstruction) {
            <button type="button" class="greyBtn ml-5" (click)="openInstruction()"
            style="font-weight : bold;">Instructions</button>
          }
          @if (addAnotherInvolvedParty != 'No' && !showSaveButton) {
            <button type="button" class="orangeBtn ml-5" (click)="addInvolvedParty(false)" [disabled]="!isFormsValid"
              [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Continue with Involved Party Selection
            </button>
          }
          @if (showSaveButton) {
            <button type="button" class="greyBtn ml-5" (click)="cancelEditInvolvedParty()">Cancel
            </button>
          }
          @if (addAnotherInvolvedParty != 'No' && showSaveButton) {
            <button type="button" class="orangeBtn ml-5" (click)="addInvolvedParty(true)" [disabled]="!isFormsValid"
              [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Save
            </button>
          }
          @if (addAnotherInvolvedParty != '' && addAnotherInvolvedParty == 'No' && !showSaveButton) {
            <button type="button" class="orangeBtn ml-5" (click)="submitInvolvedParties()"
              [ngStyle]="{'background-color': primaryColor}">Finish Involved Party Selection and Proceed to Next Section
            </button>
          }
        </div>
      </div>
      <div class="row HmsInsideContainer">
        <div class="col-md-12">
          <p role="heading" aria-level="1">Additional Involved Parties</p>
        </div>
        <div class="col-sm-12">
          <span class="col-sm-2 fs-14">Indicate if there are additional parties involved in this referral. Please note, you can edit and remove additional subjects. You cannot delete the primary subject but can edit as desired.</span>
        </div>
      </div>
      <div class="row HmsInsideContainer">
        <div class="col-md-12 involvedPartyContainer">
          <p role="heading" aria-level="1">Saved Parties ({{involvedPartyList.length + 1}})</p>
          <div class="involvedPartyDetails">
            <div class="col-md-11">
              <p role="heading" aria-level="1">Primary Involved Party: {{primaryInvolveParty.subjectType}}</p>
              <p class="fs-14">{{primaryInvolveParty.organization}}</p>
              <p class="fs-14">External Referrring Party: {{primaryInvolveParty.isExternalReferal ? 'Yes' : 'No'}}</p>
            </div>
            <div class="col-md-1" [ngStyle]="{'margin-top': (primaryInvolveParty.organization == null || primaryInvolveParty.organization.trim() == '') ? '15px' : '25px'}">
              <button type="button" class="greyBtn" style="font-weight : bold;" (click)="onEditAdditionalInvolvedParty(primaryInvolveParty)" [disabled]="showSaveButton">Edit</button>
            </div>
          </div>
          @for (item of involvedPartyList; track item; let i = $index) {
            <div class="involvedPartyDetails">
              <div class="col-md-10">
                <p role="heading" aria-level="1">Involved Party {{i + 1}}: {{item.subjectType}}</p>
                <p class="fs-14">{{item.organization}}</p>
                <p class="fs-14">External Referrring Party: {{item.isExternalReferal ? 'Yes' : 'No'}}</p>
              </div>
              <div class="col-md-2" [ngStyle]="{'margin-top': (item.organization == null || item.organization.trim() == '') ? '15px' : '25px'}">
                <button type="button" class="greyBtn" style="font-weight : bold;margin-right: 10px;margin-left: 25px;" (click)="onDeleteAdditionalInvolvedParty(item)" [disabled]="showSaveButton">Delete</button>
                <button type="button" class="greyBtn" style="font-weight : bold;" (click)="onEditAdditionalInvolvedParty(item)" [disabled]="showSaveButton">Edit</button>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="row HmsInsideContainer">
        @if (!showSaveButton) {
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <form class="userForm" [formGroup]="anotherInvolvedPartyFormPart">
              <div class="col-md-10" >
                <app-json-form [controlsData]="anotherInvolvedPartyControl" [formData]="anotherInvolvedPartyFormPart"
                (valueChangeEvent)="valueChange($event)"></app-json-form>
              </div>
            </form>
          </div>
        }
      </div>
      @if (addAnotherInvolvedParty == 'Yes' && !showSaveButton) {
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <form class="userForm" [formGroup]="involvedPartyFormPart">
              <div class="col-md-10" >
                <app-json-form [controlsData]="involvedPartyControl"
                  [formData]="involvedPartyFormPart" [textAreaCol]="30" [textAreaRows]="9"
                  [textAreaCounterPositionClass]="'pull-left'" [showTextInfo] = "false"
                (valueChangeEvent)="valueChange($event)"></app-json-form>
              </div>
            </form>
          </div>
        </div>
      }
      @if (addAnotherInvolvedParty == 'Yes' && showSaveButton) {
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <form class="userForm" [formGroup]="editInvolvedPartyFormPart">
              <div class="col-md-10" >
                <app-json-form [controlsData]="editInvolvedPartyControl"
                  [formData]="editInvolvedPartyFormPart" [textAreaCol]="30" [textAreaRows]="9"
                  [textAreaCounterPositionClass]="'pull-left'" [showTextInfo] = "false"
                (valueChangeEvent)="valueChange($event)"></app-json-form>
              </div>
            </form>
          </div>
        </div>
      }
      @if (addAnotherInvolvedParty == 'Yes' && involvedPartyTypeSelected) {
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <form class="userForm" [formGroup]="externalInvolvedPartyFormPart">
              <div class="col-md-10" >
                <app-json-form [controlsData]="externalInvolvedPartyControl" [formData]="externalInvolvedPartyFormPart"
                (valueChangeEvent)="valueChange($event)"></app-json-form>
              </div>
            </form>
          </div>
        </div>
      }
      @if (addAnotherInvolvedParty == 'Yes' && isExternalReferringParty != '') {
        <div class="row HmsInsideContainer" style="padding: 0;">
          @if (profileMasterTypeKey === 1) {
            <app-provider-details (formValidationEvent)="formValidationEvent($event)"></app-provider-details>
          }
          @if (profileMasterTypeKey === 2) {
            <app-member-details (formValidationEvent)="formValidationEvent($event)"></app-member-details>
          }
          @if (profileMasterTypeKey === 3) {
            <app-non-enumerated-provider-details (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-provider-details>
          }
          @if (profileMasterTypeKey === 4) {
            <app-non-enumerated-organization-details (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-organization-details>
          }
          @if (profileMasterTypeKey === 5) {
            <app-non-enumerated-individual-details (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-individual-details>
          }
        </div>
      }
      @if (addAnotherInvolvedParty == 'Yes' && isExternalReferringParty == 'Yes') {
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <form class="userForm" [formGroup]="additionalInvolvedPartyFormPart">
              <app-json-form [controlsData]="additionalInvolvedPartyControl"
                [formData]="additionalInvolvedPartyFormPart" [textAreaCol]="30" [textAreaRows]="2"
                [textAreaCounterPositionClass]="'pull-left'" [showTextInfo] = "false"
              (valueChangeEvent)="valueChange($event)"></app-json-form>
            </form>
          </div>
        </div>
      }

      @if (addAnotherInvolvedParty != 'No' && !showSaveButton) {
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <button type="button" class="orangeBtn pull-right" (click)="addInvolvedParty(false)" [disabled]="!isFormsValid"
              [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Continue with Involved Party Selection
            </button>
          </div>
        </div>
      }
      @if (addAnotherInvolvedParty != 'No' && showSaveButton) {
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <button type="button" class="orangeBtn ml-5 pull-right" (click)="addInvolvedParty(true)" [disabled]="!isFormsValid"
              [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Save
            </button>
            <button type="button" class="greyBtn pull-right" (click)="cancelEditInvolvedParty()">Cancel
            </button>
          </div>
        </div>
      }
      @if (addAnotherInvolvedParty != '' && addAnotherInvolvedParty == 'No' && !showSaveButton) {
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <button type="button" class="orangeBtn pull-right" (click)="submitInvolvedParties()"
              [ngStyle]="{'background-color': primaryColor}">Finish Involved Party Selection and Proceed to Next Section
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>